import Vue from 'vue';

// Управление сменой городов

export default {
  install: (App, options) => {
    App.prototype.$city = new Vue({
      ...options,
      data() {
        return {
          isConfirmationNeeded: false,
          isCityHeaderShown: false, // изм. города в хэдере
          isCityModalShown: false, // изм. города в модалке
          isCityConfirmationShown: false,
          microCities: []
        };
      },

      methods: {
        changeCity() { // данный метод управляет ТОЛЬКО модалкой/мобилкой смены города
          return new Promise((resolve, reject) => {
            const { isDesktop } = this.$options?.adaptive || {};
            isDesktop ? this.isCityModalShown = true : this.$f.showNav('selectCity');
            this.$on('city', city => {
              isDesktop ? this.isCityModalShown = false : this.$f.hideNav();
              this.$off('city');
              this.$off('city:close');
              resolve(city);
            });

            this.$on('city:close', () => {
              this.$options?.adaptive.isDesktop ? this.isCityModalShown = false : this.$f.hideNav();
              this.$off('city');
              this.$off('city:close');
              reject();
            });
          });
        },

        showCityConfirmation() { // отркыть модалку подтверждения смены макрогорода
          this.isCityConfirmationShown = true;

          return new Promise((resolve) => {
            this.$on('city-confirmation', answer => {
              this.$off('city-confirmation');
              resolve(answer);
            })
          })
        },

        hideCityConfirmation() { // закрыть модалку подтверждения смены макрогорода
          this.isCityConfirmationShown = false;
          this.isCityHeaderShown = false;
          this.$off('city-confirmation');
        },

        async loadMicroCities(cityId) { // загрузка макрогородов
          this.microCities = await this.$store.$api.loadMicroCities({ cityId });
        },

        requestConfirmation({ city, reloadPage = false }) { // запрос смены города с подтверждением
          const updateCity = (city) => {
            return this.$store.dispatch('user/updateCity', city).then(
              () => {
                if (reloadPage) {
                  window.location.reload();
                } else {
                  this.hideCityConfirmation();
                }
              }
            )
          };

          if (this.checkConfirmation(city)) {
            return this.showCityConfirmation().then(answer => {
              answer ? updateCity(city) : this.hideCityConfirmation();
              return answer;
            });
          } else {
            return updateCity(city);
          }
        },

        checkConfirmation(city) { // проверяем необходимость подтверждения смены города
          return this.isConfirmationNeeded = !this.microCities.filter(c => c.id === city.id).length;
        },
      },
    })
  },
};